export enum AppRoute {
    Home = '/',
    Contacts = '/contacts',
    Login = '/login',
    Chats = '/chats',
    Assistant = '/assistant',
    Calls = '/calls',
    VpnPlusShare = '/vpn-plus/share',
    Offline = '/offline',
    Recordings = '/recordings',
    Mail = '/mail',
    Settings = '/settings',
    Admin = '/admin',
    AdminAuthConfig = '/admin/auth/config',
    AdminMessages = '/admin/messages',
    AdminStats = '/admin/stats',
    AdminLogs = '/admin/logs',
    AdminInfrastructure = '/admin/infrastructure',
    AdminWireguard = '/admin/wireguard',
    AdminStands = '/admin/stands',
    AdminCi = '/admin/ci',
    AdminBuilds = '/admin/builds',
    AdminTerminal = '/admin/terminal',
    AdminUsers = '/admin/users',
    AdminPermissions = '/admin/permissions',
    AdminFeatures = '/admin/features',
    AdminDb = '/admin/db',
    AdminDocs = '/admin/docs',
    AdminDocsUiKit = '/admin/docs/ui-kit',
    AdminMermaid = '/admin/mermaid',
    AdminReports = '/admin/reports',
    AdminMail = '/admin/mail',
    AdminMailboxes = '/admin/mailboxes',
    Error = '/error',
    TestError = '/test-error',
    QrLogin = '/qr-login',
    TowerGame = '/games/tower',
}
